import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { Auth0Provider } from "@auth0/auth0-react";
import { BrowserRouter } from "react-router-dom";
import { LoaderProvider } from "./context/LoaderContext";
import Loading from "./components/Alert/Loading";
import { SnackbarProvider } from "./components/Common/SnackbarContext";

const onRedirectCallback = (appState: any) => {
  window.history.replaceState(
    {},
    document.title,
    appState && appState.returnTo ? appState.returnTo : window.location.pathname
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN ?? ""}
    clientId={process.env.REACT_APP_AUTH0_CLIENTID ?? ""}
    authorizationParams={{
      redirect_uri: process.env.REACT_APP_CALLBACK_URL,
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      scope: "openid profile email",
    }}
    cacheLocation="localstorage"
  >
    {/* Add this "/docdistrov2" in the basename attribute of the BrowserRouter component on deployement time */}
    <BrowserRouter basename="/docdistrov2">
      <SnackbarProvider>
        <LoaderProvider>
          <Loading />
          <App />
        </LoaderProvider>
      </SnackbarProvider>
    </BrowserRouter>
  </Auth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
